// extracted by mini-css-extract-plugin
module.exports = {"linkWrapper":"LinkWrapper_linkWrapper__yI3uW","linkAnchor":"LinkWrapper_linkAnchor__KXjrx","linkWrapperHover":"LinkWrapper_linkWrapperHover__wITfv"};